module.exports = __webpack_public_path__ + "static/media/image-lifestyle@2x.c6a6c9a8.png";